/**
 * Deterministic pseudo-count from an id so fixtures vary across agents /
 * connectors but stay stable between renders. Replaced with real aggregation
 * once session data lands in the backend.
 */
export const hashNumber = (input: string, seed: number): number => {
  let hash = seed;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};
